'use client';

import { createContext } from 'react';

// Holds the server-fetched protection plan types so useAllProtectionPlanTypes()
// can return the data synchronously without a client-side Apollo useSuspenseQuery
// round-trip. Default undefined = no provider in tree (falls through to Apollo).
const ProtectionPlanTypesContext = createContext(undefined);

export default ProtectionPlanTypesContext;
